import { FilterFields } from 'shared/mui/Filter/FilterFields/FilterFields';

import { useOrderConversionFilterFields } from './hooks/useOrderConversionFilterFields';

export const OrderConversionListFilterForm: React.FC = () => {
  const fields = useOrderConversionFilterFields();

  return <FilterFields fields={fields} />;
};
